import React from 'react'

import CloseIcon from '_assets/icons/ic-close-circle.svg'
import SaveIcon from '_assets/icons/ic-tick-circle.svg'
import Svg from '_components/svg'

import useStyles from './styles'

/**
 * Boolean cell component.
 * @param {Object} props - The props object.
 * @param {boolean} props.value - The value of the boolean cell.
 * @returns {JSX.Element} - The Boolean cell component.
 */
export const BooleanCell = ({ value }) => {
  const styles = useStyles()
  return (
    <div className={styles.default}>
      {value ? (
        <Svg icon={SaveIcon} className={styles.icon} />
      ) : (
        <Svg icon={CloseIcon} className={styles.icon} />
      )}
    </div>
  )
}
